module.exports = __webpack_public_path__ + "img/soft-skills-image-1.c2a5ea18.jpg";